import { CssBaseline } from "@material-ui/core";
import { FunctionComponent } from "react";
import FormsContext from "../../contexts/FormsContext";
import FormsContextContainer from "../../contexts/FormsContextContainer";
import AuthenticationProvider from "./AuthenticationProvider";
interface IFormsProviderProps {
  forms: FormsContextContainer;
}
const FormsProvider: FunctionComponent<IFormsProviderProps> = ({
  forms,
  children
}) => {
  return <FormsContext.Provider value={forms} data-sentry-element="FormsContext.Provider" data-sentry-component="FormsProvider" data-sentry-source-file="FormsProvider.tsx">
            <AuthenticationProvider data-sentry-element="AuthenticationProvider" data-sentry-source-file="FormsProvider.tsx">
            {/*<ThemeProvider theme={forms.theme}>*/}
                {/*<MuiPickersUtilsProvider utils={LuxonUtils}>*/}
                    <CssBaseline data-sentry-element="CssBaseline" data-sentry-source-file="FormsProvider.tsx" />
                    {/* <Router history={forms.history}> */}
                        {children}
                    {/* </Router> */}
                {/*</MuiPickersUtilsProvider>*/}
                {/*</ThemeProvider>*/}
            </AuthenticationProvider>
        </FormsContext.Provider>;
};
export default FormsProvider;